import React from 'react';

export const RetrieveCard = ({ title, icon, children }) => {
  return (
    <div
      className="retrieve-panel"
      style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      {icon ? (
        <div className="card-icon">
          <img src={icon} />
        </div>
      ) : null}
      <div className="card-title">{title}</div>
      <div>{children}</div>
    </div>
  );
};
